import React, { Suspense, lazy } from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter as Router } from 'react-router-dom';
import okrDetailsReducer from './reducers/goals/okrDetails.reducer';
import CommentsReducers from './reducers/comments.reducers';
import DirectDotedReducers from './reducers/directDoted.reducers';

const DirectDottedPage = lazy(() => import('./components/directDotedPage'));

const initMyDirectComp = (data) => {
  const rootReducer = combineReducers({
    DirectDotedReducers,
    okrDetailsReducer,
    CommentsReducers,
  });
  const directDotedStore = createStore(rootReducer, applyMiddleware(thunkMiddleware));
  render(
    <Router>
      <Provider store={directDotedStore}>
        <Suspense fallback={null}>
          <DirectDottedPage
            activeTab={data.activeTab}
            enableModule={data.enableModule}
            userHasManager={data?.userHasManager ?? false}
            userHasCoManager={data?.userHasCoManager ?? false}
          />
        </Suspense>
      </Provider>
    </Router>,
    document.getElementById('mywobo-direct-dotted-wrapper')
  );
};

window.initMyDirectComp = initMyDirectComp;
